import {Directive, ElementRef, HostListener, Input, OnInit} from '@angular/core';
import {ImageService} from '../services/image.service';

@Directive({
  selector: '[lazyImage]'
})
export class LazyImageDirective implements OnInit {
  @Input('lazyImage') userId!: string;
  @Input('lazyImagePhotoId') photoId!: string | null;
  /** Fallback-Bild bei fehlendem Foto oder Ladefehler. Überschreibbar via [lazyImageFallback]. */
  @Input('lazyImageFallback') fallback = 'assets/img/no-picture.png';

  private observer!: IntersectionObserver;

  constructor(
    private el: ElementRef<HTMLImageElement>,
    private imageService: ImageService
  ) {
  }

  ngOnInit() {
    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.loadImage();
          this.observer.unobserve(entry.target);
        }
      });
    });

    this.observer.observe(this.el.nativeElement);
  }

  /** Greift, wenn die gesetzte Quelle nicht lädt (z. B. defektes Thumbnail); Loop-Schutz gegen ein fehlendes Fallback-Bild. */
  @HostListener('error')
  onError(): void {
    if (this.el.nativeElement.src.endsWith(this.fallback)) return;
    this.el.nativeElement.src = this.fallback;
  }

  private loadImage() {
    if (!this.photoId) {
      this.el.nativeElement.src = this.fallback;
      return;
    }

    this.imageService.getThumbnail(this.userId, this.photoId)
      .subscribe({
        next: (blob) => {
          this.el.nativeElement.src = URL.createObjectURL(blob);
        },
        error: () => {
          this.el.nativeElement.src = this.fallback;
        }
      });
  }
}
